







































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { ValidationObserver, ValidationProvider, extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import Swal from 'sweetalert2';

extend('required', required);

export interface Contact {
  id: never;
  name: never;
  tel: never;
  address: never;
}

@Component({
})
export default class ContactList extends Vue {
    private toggle = false;
    private filrer = '';
    private contact = [] as Contact[];
    private selectAll = false;
    private loading = false;
    private selectedContact = [];
    private selectMode = false;
    private receiverContact = false;
    private refCode = '';
    private pdfOptions = {
        'A4': 'A4',
        '10x10': '2.5"x4.0"',
    };

    private created() {
      this.loading = true;
      this.$http.get(`/api/address?timestamp=${Date.now()}`).then((response: any) => {
        this.getContacts();
      }, (err: any) => {
        if (err.status === 404) {
          this.$router.push({ path: 'sender' });
        }
      });
    }

    get hasContact() {
      return this.contact.length > 0;
    }

    private getContacts() {
      this.refCode = this.$route.params.refCode;
      if (this.refCode) {
        this.getRequestContact();
      } else {
        this.getContact();
      }
    }

    private filteredList() {
      return this.contact.filter((c: any) => {
        const name = c.name.toLowerCase().includes(this.filrer.toLowerCase());
        const tel = c.tel.toLowerCase().includes(this.filrer.toLowerCase());
        return  name || tel;
      });
    }

    @Watch('selectAll')
    private selectAllChange(value: string, oldValue: string) {
      if (value) {
        this.selectedContact = [];
        for (const c of this.contact) {
          // index start from 0
          if (this.selectedContact.length > 19) {
            break;
          } else {
            this.selectedContact.push(c.id);
          }
        }
      } else {
        this.selectedContact = [];
      }
    }

    @Watch('selectMode')
    private selectModeChange(value: string, oldValue: string) {
      if (!value) {
        this.selectedContact = [];
      }
    }

    private viewContact(id: string) {
      if (this.selectMode) {
        const index = this.selectedContact.indexOf(id);
        if (index >= 0) {
          this.selectedContact.splice(index, 1 );
        } else {
          this.selectedContact.push(id);
        }
      } else {
        this.$router.push({ name: 'viewContact', params: { id } });
      }
    }

    private getRequestContact() {
      this.$http.get(`/api/address/contact-list/${this.refCode}`).then((response: any) => {
        this.contact = response.data;
        this.loading = false;
      }, (err: any) => {
        this.loading = false;
      });
    }

    private getContact() {
      this.$http.get(`/api/address/contact-list`).then((response: any) => {
        this.contact = response.data;
        this.loading = false;
      }, (err: any) => {
        this.loading = false;
      });
    }

    private trackingLabel() {
      Swal.fire({
          title: 'เลือกขนาดใบจ่าหน้า',
          input: 'radio',
          inputOptions: this.pdfOptions,
          focusConfirm: false,
          confirmButtonText: 'ยืนยัน',
          confirmButtonColor: '#ec1b23',
          preConfirm: (value) => {
              if (value) {
                  return new Promise((resolve) =>  {
                      resolve();
                  });
              } else {
                  return false;
              }
          },
      }).then((result) => {
          if (result.value) {
              this.submitGeneratePdf(result.value);
          }
      });
    }

    private submitGeneratePdf(pdfSize: any) {
      Swal.fire({
        title: 'ระบบกำลังดำเนินการ<br />สร้างใบจ่าหน้า',
        allowOutsideClick: false,
        onBeforeOpen: () => {
          Swal.showLoading();
        },
      });
      const contactId = this.selectedContact;
      const body = {
        id: contactId,
      };
      this.$http.post(`/api/address/delivery-list-gen-pdf/${pdfSize}`, body).then((response: any) => {
        if (response.body.task === 'SendPdf') {
                const taskBody = JSON.parse(response.body.message);
                if (taskBody.link !== null) {
                  let notGenMsg = null;
                  if (taskBody.notGen.length >= 1) {
                    notGenMsg = '<div class="gen-pdf-response">ยกเว้นที่ไม่พบหมายเลขไปรษณีย์';
                    taskBody.notGen.forEach((notGen) => {
                      notGenMsg = notGenMsg + `<p>- ${notGen.name}</p>`;
                    });
                  }
                  Swal.fire({
                        allowOutsideClick: false,
                        title: 'สร้างใบจ่าหน้าสำเร็จ',
                        html: notGenMsg,
                        focusConfirm: false,
                        focusCancel: false,
                        showCancelButton: true,
                        confirmButtonText: 'ดาวน์โหลด',
                        confirmButtonColor: '#ec1b23',
                        cancelButtonText: 'ปิด',
                    }).then((result) => {
                        if (result.value) {
                            window.open(`${taskBody.link}?openExternalBrowser=1`);
                        }
                    });
                } else {
                     Swal.fire({
                        title: 'สร้างใบจ่าหน้าไม่สำเร็จ',
                        text: 'ไม่สามารถสร้างใบจ่าหน้าได้เพราะไม่พบรหัสไปรษณีย์ กรุณาลองอีกครั้ง',
                        focusConfirm: false,
                        focusCancel: false,
                        confirmButtonText: 'ตกลง',
                        confirmButtonColor: '#ec1b23',
                    }).then();
                }
            } else {
                Swal.fire({
                    title: 'ไม่สามารถทำรายการได้ในขณะนี้',
                    text: 'กรุณาลองอีกครั้ง',
                    focusConfirm: false,
                    focusCancel: false,
                    confirmButtonText: 'ตกลง',
                    confirmButtonColor: '#ec1b23',
                }).then();
            }
      }, (err: any) => {
          if (err.status === 504) {
            Swal.fire({
                title: 'ระบบกำลังดำเนินการ<br />สร้างใบจ่าหน้า',
                html: 'ตรวจสอบได้ที่ประวัติใบจ่าหน้า',
                focusConfirm: false,
                focusCancel: false,
                confirmButtonText: 'ตกลง',
                confirmButtonColor: '#ec1b23',
            }).then();
          } else {
            Swal.fire({
                title: 'เกิดข้อผิดพลาด',
                focusConfirm: false,
                focusCancel: false,
                confirmButtonText: 'ตกลง',
                confirmButtonColor: '#ec1b23',
            }).then();
          }
      });
    }

    private deleteContact() {
      Swal.fire({
          title: 'ต้องการลบรายชื่อนี้ใช่หรือไม่',
          text: 'หากยืนยันการลบแล้วข้อมูลจะไม่สามารถกู้คืนได้',
          showCancelButton: true,
          confirmButtonText: 'ยืนยัน',
          cancelButtonText: 'ยกเลิก',
          confirmButtonColor: '#ec1b23',
          reverseButtons: true,
      }).then((result) => {
          if (result.value) {
              this.confirmedDelete();
          }
      });
    }

    private confirmedDelete() {
      const contactId = this.selectedContact.toString();
      this.$http.delete(`/api/address/${contactId}`).then((response: any) => {
        Swal.fire({
          allowOutsideClick: false,
          title: 'ลบข้อมูลสำเร็จ',
          focusConfirm: false,
          focusCancel: false,
          confirmButtonText: 'ยืนยัน',
          confirmButtonColor: '#ec1b23',
        }).then((result) => {
          if (result.value) {
            this.selectedContact = [];
            this.getContact();
          }
        });
      }, (err: any) => {
        Swal.fire({
            title: 'เกิดข้อผิดพลาด',
            focusConfirm: false,
            focusCancel: false,
            confirmButtonText: 'ตกลง',
            confirmButtonColor: '#ec1b23',
        }).then();
      });
    }
}
